let debounce = require('lodash.debounce');
export function infoButton() {
    //Adjusting infoButton HTML for 'linkWithDescription' - Move HTML into picture element
    var listingImage = document.getElementsByClassName('promo-listing-image');
    var listingImageInfoButton;
    function setPanelContainerWidth(listingImageContainer) {
        Object.keys(listingImageContainer).forEach(item => {
            listingImageInfoButton = listingImage[item].getElementsByClassName('info-button')[0]; // button
            if (typeof listingImageInfoButton !== 'undefined') {
                listingImageInfoButton.style.width = `${listingImage[item].getElementsByTagName('picture')[0].offsetWidth}px`;
            }
        })
    }

    Object.keys(listingImage).forEach(item => {
        listingImageInfoButton = listingImage[item].getElementsByClassName('info-button')[0]; // button
        if (typeof listingImageInfoButton !== 'undefined') { // if button exist 
            listingImage[item].getElementsByClassName('info-button')[0].remove(); // belete button block element from DOM
            listingImage[item].getElementsByTagName('picture')[0].style = "position: relative"; // set style to picture element
           // listingImage[item].getElementsByTagName('picture')[0].innerHTML += listingImageInfoButton.outerHTML; // pass button to picture element
            listingImage[item].style.position = "relative";
            listingImageInfoButton.style.position = "absolute";
            listingImage[item].innerHTML += listingImageInfoButton.outerHTML; // pass button to picture element
        }
    }); 

    setPanelContainerWidth(listingImage)
   
    function addDefaultPosition(infoButton: HTMLElement, defaultPositionClass = 'top-left') {
        if (!infoButton.classList.contains('top-left') &&
            !infoButton.classList.contains('top-right') &&
            !infoButton.classList.contains('bottom-left') &&
            !infoButton.classList.contains('bottom-right')) {
            infoButton.classList.add(defaultPositionClass);  //Default info button top left if no class assigned
        }
    }
    function togglePanel(infoButton: HTMLElement, isHide: boolean = false) {
        const button = infoButton.querySelector('button');
        const panel: HTMLElement = infoButton.querySelector('.info-button-panel');
        panel.setAttribute('aria-hidden', isHide ? 'true' : 'false');
        panel.style.overflow = isHide ? '' : 'visible';
        button.setAttribute('aria-expanded', isHide ? 'false' : 'true');
    }
    function closePanel(infoContainer: HTMLElement) {
        infoContainer.setAttribute('itemAriaEx', 'false');
        togglePanel(infoContainer, true);
    }
    const infoButton = document.getElementsByClassName('info-button');
    let checkedInfoButton: HTMLElement | null;
    document.addEventListener('click', (event) => {
        if (checkedInfoButton) {
            if (!event.composedPath().some(i => i === checkedInfoButton)) {
                Object.keys(infoButton).forEach(item => {
                    closePanel(infoButton[item])
                })
            }
        }
    })
    Object.keys(infoButton).forEach(item => {

        //Setting default info button position if it has not already been set
        addDefaultPosition(infoButton[item]);

        //On blur close caption
        const button = infoButton[item].querySelector('button');
        const panel: HTMLElement = infoButton[item].querySelector('.info-button-panel');
        setTimeout(() => {
            setPanelsHeight()
        }, 100)
        
        if (button) {
            infoButton[item].setAttribute('itemAriaEx', false);
            let ariaExpanded = false;
            infoButton[item].addEventListener('click', (event) => {
                checkedInfoButton = infoButton[item];
                Object.keys(infoButton).forEach(i => {
                    if (infoButton[item] !== infoButton[i]) {
                        closePanel(infoButton[i])
                    }
                })
                const clickOnButton = event.composedPath().includes(button);
                const clickOnPanel = event.composedPath().includes(panel);
                if (clickOnButton) {
                    ariaExpanded = !ariaExpanded;
                    infoButton[item].setAttribute('itemAriaEx', infoButton[item].getAttribute('itemAriaEx') !== 'true');
                    setTimeout(() => {
                        togglePanel(infoButton[item], !(infoButton[item].getAttribute('itemAriaEx') === 'true'));
                    }, 0)
                }
                else if (clickOnPanel) { }
                else {
                    if (infoButton[item].getAttribute('itemAriaEx') === 'true') {
                        closePanel(infoButton[item]);
                    }
                }
            })         
        }
    });

    function setPanelsHeight() {
        Object.keys(infoButton).forEach(item => {
            const panel: HTMLElement = infoButton[item].querySelector('.info-button-panel');
            const panelContainer = infoButton[item].querySelector('.background-caption-panel');
            const bgContent = panel.querySelector('.background-caption-content');
            if (bgContent) {
                panel.style.height = `auto`
                //panel.style.maxHeight = `200px`;
                //panel.style.transition = `1s max-height`;
            }
            if (panelContainer) {
                panelContainer.style.maxHeight = 'initial';
            }
        })
    }
    window.addEventListener(
        'resize',
        debounce(() => {
            setPanelContainerWidth(listingImage)
            setPanelsHeight();
        }, 200)
    );

} 
